/* Her Part ELI5 story LP (staging). No libraries. Countdown, plan select, carousel, spin-to-win, confetti. */
(function () {
  var root = document.getElementById('e5');
  if (!root) return;
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var KEY = 'hp_eli5_gifts_won';
  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }
  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  /* smooth scroll to buy box */
  function toBuy(sel) {
    var t = (sel && $(sel)) || document.getElementById('e5-buy');
    if (!t) return;
    var bar = $('.e5-bar');
    var y = t.getBoundingClientRect().top + window.pageYOffset - (bar ? bar.offsetHeight : 0) - 16;
    window.scrollTo({ top: y, behavior: RM ? 'auto' : 'smooth' });
  }
  $$('[data-e5-scroll]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); toBuy(); }); });

  /* countdown to local midnight */
  var cd = $('[data-e5-countdown]');
  if (cd) {
    var h = $('[data-cd=h]', cd), m = $('[data-cd=m]', cd), s = $('[data-cd=s]', cd);
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0);
      var d = Math.max(0, Math.floor((end - now) / 1000));
      h.textContent = pad(Math.floor(d / 3600)); m.textContent = pad(Math.floor(d % 3600 / 60)); s.textContent = pad(d % 60);
    };
    tick(); setInterval(tick, 1000);
  }

  /* plan select */
  var buy = $('[data-e5-buy]'), renew = $('[data-e5-renew]');
  function pick(plan) {
    $$('.e5-plan').forEach(function (p) {
      var on = p === plan; p.classList.toggle('is-on', on); $('input', p).checked = on;
    });
    if (buy) buy.href = plan.getAttribute('data-href');
    if (renew) renew.textContent = plan.getAttribute('data-renew');
  }
  $$('.e5-plan').forEach(function (p) {
    $('input', p).addEventListener('change', function () { pick(p); });
    p.addEventListener('click', function (e) { if (!e.target.closest('label')) pick(p); });
  });

  /* gallery thumbs */
  var galMain = $('[data-e5-galmain]');
  $$('.e5-thumb').forEach(function (t) { t.addEventListener('click', function () { $$('.e5-thumb').forEach(function (x) { x.classList.toggle('is-on', x === t); }); if (galMain && t.getAttribute('data-src')) { galMain.removeAttribute('srcset'); galMain.src = t.getAttribute('data-src'); galMain.alt = t.getAttribute('data-alt') || ''; } }); });

  /* reviews carousel */
  var car = $('[data-e5-carousel]');
  if (car) {
    var slides = $$('.e5-rcard', car), idx = 0, out = $('[data-e5-idx]', car);
    $$('.e5-arrow', car).forEach(function (b) {
      b.addEventListener('click', function () {
        idx = (idx + Number(b.getAttribute('data-dir')) + slides.length) % slides.length;
        slides.forEach(function (sl, i) { sl.hidden = i !== idx; });
        out.textContent = idx + 1;
      });
    });
  }

  /* confetti, brand colours */
  var cv = $('[data-e5-confetti]');
  function confetti() {
    if (RM || !cv) return;
    var ctx = cv.getContext('2d'), dpr = window.devicePixelRatio || 1;
    var W = window.innerWidth, H = window.innerHeight;
    cv.width = W * dpr; cv.height = H * dpr; ctx.scale(dpr, dpr); cv.classList.add('is-on');
    var cols = ['#9B2236', '#C9475E', '#F3D9DD', '#E7B9C0', '#FAF4EC', '#2A181C'], P = [];
    for (var i = 0; i < 180; i++) P.push({ x: Math.random() * W, y: -20 - Math.random() * H * .6, w: 6 + Math.random() * 6, h: 8 + Math.random() * 8, vx: -1.5 + Math.random() * 3, vy: 2 + Math.random() * 3.5, r: Math.random() * 6.28, vr: -.2 + Math.random() * .4, c: cols[i % cols.length] });
    var t0 = performance.now();
    (function frame(t) {
      ctx.clearRect(0, 0, W, H);
      P.forEach(function (p) { p.x += p.vx; p.y += p.vy; p.vy += .04; p.r += p.vr; ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.fillStyle = p.c; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h); ctx.restore(); });
      if (t - t0 < 3800) requestAnimationFrame(frame); else { ctx.clearRect(0, 0, W, H); cv.classList.remove('is-on'); }
    })(t0);
  }

  /* spin to win */
  var spin = $('[data-e5-spin]'), btn = $('[data-e5-spinbtn]'), status = $('[data-e5-status]');
  var gifts = $('[data-e5-gifts]');
  var tpl = function (n) { var t = $('[data-e5-tpl-' + n + ']'); return t ? t.innerHTML.trim() : ''; };
  var state = 'idle';
  function showGifts(animate) {
    if (!gifts) return;
    gifts.hidden = false;
    if (animate) { gifts.classList.remove('is-new'); void gifts.offsetWidth; gifts.classList.add('is-new'); }
  }
  function landTiles() {
    $$('.e5-tile', spin).forEach(function (tile) {
      var strip = $('.e5-reel__strip', tile), cells = $$('.e5-reel__cell', strip);
      strip.style.transition = 'none';
      strip.style.transform = 'translateY(-' + (cells.length - 1) * 100 / cells.length + '%)';
      var l = $('.e5-tile__l', tile); l.textContent = l.getAttribute('data-won');
    });
  }
  function setWon(fromStore) {
    state = 'won';
    spin.classList.add('is-won');
    landTiles();
    status.hidden = false; status.textContent = tpl('won');
    btn.disabled = false; btn.textContent = btn.getAttribute('data-won');
    if (fromStore) showGifts(false);
  }
  if (spin && btn) {
    if (store(KEY) === '1') setWon(true);
    btn.addEventListener('click', function () {
      if (state === 'won') { var kit = $('.e5-plan[data-plan=kit]'); if (kit) pick(kit); showGifts(true); toBuy('.e5-plans'); return; }
      if (state !== 'idle') return;
      state = 'spinning';
      btn.disabled = true; btn.textContent = btn.getAttribute('data-busy');
      status.hidden = false; status.textContent = tpl('spinning');
      if (RM) { store(KEY, '1'); setWon(false); return; }
      var tiles = $$('.e5-tile', spin), done = 0;
      tiles.forEach(function (tile, i) {
        var strip = $('.e5-reel__strip', tile), n = $$('.e5-reel__cell', strip).length;
        var dur = 1600 + i * 450;
        strip.style.transition = 'none'; strip.style.transform = 'translateY(0)';
        void strip.offsetHeight;
        strip.style.transition = 'transform ' + dur + 'ms cubic-bezier(.15,.85,.25,1.02)';
        strip.style.transform = 'translateY(-' + (n - 1) * 100 / n + '%)';
        setTimeout(function () {
          var l = $('.e5-tile__l', tile); l.textContent = l.getAttribute('data-won');
          if (++done === tiles.length) { store(KEY, '1'); setWon(false); confetti(); }
        }, dur + 60);
      });
    });
  }
})();
